import axios from "axios";
import {API_BASE_URL_V2} from "../../services/config";

// Get user timezone
export const getTimezoneService = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_BASE_URL_V2 + "timezone", config);

  const responseData = response.data;
  if (responseData.data?.coachliTimezone) {
    return {
      ...responseData,
      data: {
        ...responseData.data,
        timeZone: responseData.data.coachliTimezone,
      },
    };
  }

  return responseData;
};

// update user timezone
export const updateTimezoneService = async (timezone: string, token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const payload = {timezone};

  const response = await axios.post(API_BASE_URL_V2 + "timezone", payload, config);

  const responseData = response.data;
  if (responseData.data?.coachliTimezone) {
    return {
      ...responseData,
      data: {
        ...responseData.data,
        timeZone: responseData.data.coachliTimezone,
      },
    };
  }

  return responseData;
};
